import { QuoteStatusToDealStageMappingForm } from '@monetize/types/app';
import { FC } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { BsArrowRight } from 'react-icons/bs';
import {
  MFlex,
  MFormField,
  MIcon,
  MText,
} from '../../../../../../../components/Monetize';
import { MCustomSelect } from '../../../../../../../components/Monetize/MCustomSelect/MCustomSelect';

interface MappingRowProps {
  index: number;
  control: Control<QuoteStatusToDealStageMappingForm>;
  quoteStatuses: Array<{ label: string; value: string }>;
  dealStages: Array<{ label: string; value: string }>;
  errors: FieldErrors<QuoteStatusToDealStageMappingForm>;
}

export const MappingRow: FC<MappingRowProps> = ({
  index,
  control,
  quoteStatuses,
  dealStages,
  errors,
}) => {
  const dealStageError = errors?.mappings?.[index]?.attioDealStageId;

  return (
    <MFlex gap={4} align="flex-start">
      <MFlex direction="column" flex={1}>
        {index === 0 && (
          <MText fontSize="sm" fontWeight="medium" mb={2}>
            Quote Status
          </MText>
        )}
        <Controller
          name={`mappings.${index}.mnQuoteStatus`}
          control={control}
          render={({ field: { value } }) => {
            const statusLabel =
              quoteStatuses.find((s) => s.value === value)?.label || value;
            return (
              <MText fontSize="md" py={2}>
                {statusLabel}
              </MText>
            );
          }}
        />
      </MFlex>
      <MIcon as={BsArrowRight} mt={index === 0 ? 9 : 2} />
      <MFormField
        label={index === 0 ? 'Deal Stage' : undefined}
        error={dealStageError}
        flex={1}
      >
        <Controller
          name={`mappings.${index}.attioDealStageId`}
          control={control}
          render={({ field: { onChange, value } }) => (
            <MCustomSelect
              placeholder="Deal Stage"
              items={dealStages}
              itemTitle="label"
              itemValue="value"
              useMainInputAsSearchInput
              clearable
              value={value}
              onChange={onChange}
            />
          )}
        />
      </MFormField>
    </MFlex>
  );
};
